import React, { useState } from 'react';
import Modal, { MarketModalConfig } from './components/MarketModal/MarketModal';
import { loadStripe } from '@stripe/stripe-js';
import { Web3Modal, Web3Button, useWeb3Modal } from '@web3modal/react'
import { configureChains, createConfig, WagmiConfig } from 'wagmi'
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { arbitrum, mainnet, polygon } from 'wagmi/chains'

const chains = [arbitrum, mainnet, polygon]
const projectId = process.env.REACT_APP_WC_PROJECT_ID || ''

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient
})

const ethereumClient = new EthereumClient(wagmiConfig, chains)

const App: React.FC = () => {
  const queryParameters = new URLSearchParams(window.location.search)
  const skipPayment = queryParameters.get("payment") != "true"

  var markets = queryParameters.get("market")?.split(",")
  if(!markets) {
    markets = process.env.REACT_APP_MARKETS == "" ? []: process.env.REACT_APP_MARKETS?.split(",")
  }

  var cryptoCurrencies = queryParameters.get("crypto")?.split(",")
  if(!cryptoCurrencies) {
    cryptoCurrencies = process.env.REACT_APP_CRYPTO_CURRENCIES == "" ? []: process.env.REACT_APP_CRYPTO_CURRENCIES?.split(",")
  }

  var addr = queryParameters.get("addr")
  const handleOpenModal = () => {};
  const handleCloseModal = () => {};

  const stripe = loadStripe(
    process.env.REACT_APP_STRIPE_PK || ""
  );

  const [walletAddr, setWalletAddr] = useState(addr? addr : "0x71C7656EC7ab88b098defB751B7401B5f6d8976F")
  const config: MarketModalConfig = {
    userInfo: {
      externalUserId: "12345",
      walletAddress: walletAddr,
    },
    cryptocurrencies: cryptoCurrencies? cryptoCurrencies: [],
    demo: true,
    skipPayment: false,
    markets: markets? markets: ["superlink","ens"],
    stripe: {
      stripe: stripe,
      connectedAccountId: process.env.REACT_APP_STRIPE_CONNECT_ACCOUNT_ID || "",
    },
    apiUrl: process.env.REACT_APP_API_URL || undefined,
  }

  const styledWeb3Button = Web3Button({icon: "show", label: "Click here to start"})
  const { open, isOpen } = useWeb3Modal();

  return (
    <>
      <WagmiConfig config={wagmiConfig}>
        {styledWeb3Button}
        <Modal onOpen={handleOpenModal} onClose={handleCloseModal} initialNotConnected={open} setWalletAddr={setWalletAddr} config={config} />
      </WagmiConfig>
      <Web3Modal projectId={projectId} ethereumClient={ethereumClient} />
    </>
    );
};

export default App;